// frontend/src/App.js
import React from "react";
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route, Navigate } from "react-router-dom";
import AppContent from "./AppContent";

function App({ socket }) {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<AppContent socket={socket} />}>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    )
  );

  return <RouterProvider router={router} />;
}

export default App;
